type LogCategory = 'service' | 'public-banner' | 'internal-banner' | 'provider' | 'sdk' | 'consent' | 'hb' | 'detector'

export enum LogLevel {
    log = 0,
    debug = 1,
}

const COLORS: Record<LogCategory, string> = {
    service: '#4A90E2',
    'public-banner': '#27AE60',
    'internal-banner': '#F39C12',
    provider: '#E67E22',
    sdk: '#E67E22',
    consent: '#9B59B6',
    hb: '#E74C3C',
    detector: '#16A085',
}

function readDebugQuery(win?: Window | null): boolean {
    try {
        return new URLSearchParams(win?.location.search ?? '').has('debug')
    } catch {
        return false
    }
}

let logLevel: LogLevel = (() => {
    if (typeof window === 'undefined') {
        return LogLevel.log
    }
    for (const win of new Set([window.top, window])) {
        if (readDebugQuery(win)) {
            return LogLevel.debug
        }
    }
    return LogLevel.log
})()

export function setAdConsoleLoggerLevel(level: LogLevel) {
    logLevel = level
}

export class AdConsoleLogger {
    private readonly tag: string
    private readonly style: string

    constructor(category: LogCategory, context?: string) {
        this.tag = `[PLAYGAMA ADV:${category}${context ? `:${context}` : ''}]`
        this.style = `color:${COLORS[category]};font-weight:bold`
    }

    private time() {
        return new Date().toISOString().slice(11, 23)
    }

    debug(...args: unknown[]) {
        if (logLevel >= LogLevel.debug) {
            console.info(`%c${this.tag}`, this.style, this.time(), ...args)
        }
    }

    log(...args: unknown[]) {
        if (logLevel >= LogLevel.log) {
            console.info(`%c${this.tag}`, this.style, this.time(), ...args)
        }
    }

    error(...args: unknown[]) {
        if (logLevel >= LogLevel.log) {
            console.error(`%c${this.tag}`, this.style, this.time(), ...args)
        }
    }
}
